import { useState } from 'react';

import { Combobox } from '@base-ui/react/combobox';

import { useEvent } from '@hooks/use-event';

// The query and open state of a chips select. base-ui closes a multiple
// combobox after a pick made while the input holds a query; the list stays
// open instead, with the query cleared so the next pick starts fresh.
export const useChipsPopup = (onQueryCleared?: () => void) => {
  const [inputValue, setInputValue] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = useEvent((open: boolean, details: Combobox.Root.ChangeEventDetails) => {
    if (!open && details.reason === 'item-press') {
      details.cancel();
      setInputValue('');
      onQueryCleared?.();
      return;
    }
    setIsOpen(open);
  });

  return { inputValue, setInputValue, isOpen, setIsOpen, handleOpenChange };
};
